"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssignmentNodeDependencies = void 0;
var _dependenciesMatrixGenerated = require("./dependenciesMatrix.generated.js");
var _dependenciesNodeGenerated = require("./dependenciesNode.generated.js");
var _dependenciesSubsetGenerated = require("./dependenciesSubset.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var AssignmentNodeDependencies = exports.AssignmentNodeDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated.matrixDependencies,
  NodeDependencies: _dependenciesNodeGenerated.NodeDependencies,
  subsetDependencies: _dependenciesSubsetGenerated.subsetDependencies,
  createAssignmentNode: _factoriesAny.createAssignmentNode
};